import { ProfileLabelsWidgetItem } from '../../../../Widget'

function RequestProfileWidgetLabelsItem({
  canDelete,
  id,
  onDelete,
  ...restProps
}) {
  function handleRemove() {
    onDelete(id)
  }

  return (
    <ProfileLabelsWidgetItem
      {...restProps}
      removeTooltipKey='Modal.DeleteBtnKey'
      onRemove={canDelete ? handleRemove : undefined}
    />
  )
}

export default RequestProfileWidgetLabelsItem
